/** Page rubrique en préparation (carte cadeau, univers). */
import { useI18n } from '../i18n';
import { PageHeader } from '../components/PageHeader';
import './ComingSoonScreen.css';

export function ComingSoonScreen({ titleKey }: { titleKey: string }) {
  const { t } = useI18n();
  return (
    <div className="mb-soon">
      <PageHeader title={t(titleKey)} />
      <main className="mb-soon-main">
        <p className="mb-soon-eyebrow">{t(titleKey)}</p>
        <h2 className="mb-soon-title">{t('soon_title')}</h2>
        <p className="mb-soon-body">{t('soon_body')}</p>
      </main>
    </div>
  );
}
